<template>
  <main>
    <div class="md:px-12 max-w-screen-2xl mx-auto">
      <!-- Hero section implementation -->
      <div
        class="flex flex-col lg:flex-row items-center justify-center space-y-6 lg:space-y-0 lg:space-x-8 py-10"
      >
        <!-- MMC -->
        <div class="w-full lg:w-1/2 flex justify-center">
          <div class="text-center">
            <img
              src="../assets/images/Ellipse 6 (1).png"
              alt="MMC"
              class="object-cover w-2/3 mx-auto"
            />
            <div class="mt-4 md:mb-8">
              <h4 class="text-lg font-bold">Mshel Real Estate Masterclass</h4>
              <router-link
                to="/mshel-mentorship-club"
                class="mt-4 inline-block px-4 py-2 bg-blue text-xl text-white rounded transition-transform transform hover:scale-110 focus:outline-none focus:ring focus:ring-blue-300"
              >
                Register Here
              </router-link>
            </div>
          </div>
        </div>

        <!-- MREM -->
        <div class="w-full lg:w-1/2 flex justify-center">
          <div class="text-center">
            <img
              src="../assets/images/Ellipse 7.png"
              alt="MREC"
              class="object-cover w-2/3 mx-auto"
            />
            <div class="mt-4 md:mb-8">
              <h4 class="text-lg font-bold">Mshel Real Estate Masterclass</h4>
              <router-link
                to="/mshel-realestate-masterclass-club"
                class="mt-4 inline-block px-4 py-2 bg-blue text-xl text-white rounded transition-transform transform hover:scale-110 focus:outline-none focus:ring focus:ring-blue-300"
              >
                Register Here
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- About the Mshel Mentrship club implementation section -->
      <div class="py-12">
        <h4 class="text-center text-lg font-semibold">
          About Mshel Mentorship Club (MMC)
        </h4>
        <p class="mt-6">
          Lorem ipsum dolor sit amet consectetur, sollicitudin tincidunt
          molestie senectus consectetur sagittis consectetur pellentesque
          ullamcorper hendrerit dolor nisi sit, consectetur pellentesque
          ullamcorper hendrerit dolor nisi sit.Lorem ipsum dolor sit amet
          consectetur. Sollicitudin tincidunt molestie senectus consectetur
          sagittis sit tortor imperdiet arcu lorem ipsum dolor sit amet
          consectetur sit tortor imperdiet arcu. Lorem ipsum dolor sit amet
          consectetur.
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur. Sollicitudin tincidunt
          molestie senectus consectetur sagittis sit tortor imperdiet arcu.
          Lorem ipsum dolor sit amet consectetur. Sollicitudin tincidunt
          molestie senectus consectetur sagittis sit tortor imperdiet arcu.
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur. Sollicitudin tincidunt
          molestie senectus consectetur sagittis sit tortor imperdiet arcu.
          Lorem ipsum dolor sit amet consectetur. Sollicitudin tincidunt
          molestie senectus consectetur sagittis sit tortor imperdiet arcu.
        </p>
      </div>

      <!-- Training Topics Section-->
      <section
        class="container py-32 md:px-12 sm:px-12 px-4 max-w-screen-2xl mx-auto bg-cover bg-center mb-10"
        :style="{
          backgroundImage: `url(${require('../assets/images/hero-section.jpg')})`,
        }"
      >
        <div class="bg-black bg-opacity-50"></div>
        <h1 class="text-lg font-bold lg:text-start text-[#ada595] mb-8 -mt-6">
          Training Topics
        </h1>
        <!-- First Row Trainings -->
        <div class="grid grid-cols-1 md:grid-cols-4 gap-2">
          <!-- Leadership Card -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Leadership
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module on Leadership nurtures essential skills such as
                communication, decision-making, and team management, empowering
                individuals to inspire and guide others effectively.
              </h3>
            </div>
          </div>

          <!-- Financial Management Card -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Financial Management
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module on Financial Management teaches in detail the
                principles of financial budgeting, investment, and risk
                assessment, empowering individuals to make informed decisions
                and achieve long-term financial stability.
              </h3>
            </div>
          </div>

          <!-- Networking Card -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Networking
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                Coaching underscores the significance of networking, teaching
                individuals how to cultivate meaningful connections. Through
                mentorship and guidance, coaching facilitates opportunities for
                professional growth.
              </h3>
            </div>
          </div>

          <!-- Investment & Strategy Planning Card -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Investment & Strategy Planning
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                A module on Investment and Strategy Planning impacts knowledge
                on analyzing markets, identifying opportunities, and developing
                robust plans to achieve financial goals effectively.
              </h3>
            </div>
          </div>
        </div>

        <!-- Second Row Trainings -->
        <div class="grid grid-cols-1 md:grid-cols-4 gap-2 mt-6">
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Business Development & Strategy
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This session on Business Development and strategy equips
                participants with tools and frameworks to identify growth
                opportunities, innovate, and navigate competitive landscapes
                successfully.
              </h3>
            </div>
          </div>

          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Spiritual Formation
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module attempts to explore True Relation with God, being
                Christ centric and creates guidance on spiritual growth, with a
                sense of purpose to life.
              </h3>
            </div>
          </div>

          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Marriage & Parenting
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module explores Marriage and Parenting which provides
                insights and skills to navigate relationships, communication,
                and child mentoring, fostering healthy and fulfilling family
                dynamics.
              </h3>
            </div>
          </div>

          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Wealth Management
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This session on Wealth Management educates individuals on
                investment strategies, financial planning, and risk mitigation
                techniques to achieve long-term financial security and
                prosperity.
              </h3>
            </div>
          </div>
        </div>
      </section>

      <!-- About the Mshel Real Estate Masterclasses section  -->
      <div class="py-12">
        <h4 class="text-center text-lg font-semibold">
          About Mshel Real Estate Masterclass (MREM)
        </h4>
        <p class="mt-6">
          Lorem ipsum dolor sit amet consectetur, sollicitudin tincidunt
          molestie senectus consectetur sagittis consectetur pellentesque
          ullamcorper hendrerit dolor nisi sit, consectetur pellentesque
          ullamcorper hendrerit dolor nisi sit.Lorem ipsum dolor sit amet
          consectetur. Sollicitudin tincidunt molestie senectus consectetur
          sagittis sit tortor imperdiet arcu lorem ipsum dolor sit amet
          consectetur sit tortor imperdiet arcu. Lorem ipsum dolor sit amet
          consectetur.
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur. Sollicitudin tincidunt
          molestie senectus consectetur sagittis sit tortor imperdiet arcu.
          Lorem ipsum dolor sit amet consectetur. Sollicitudin tincidunt
          molestie senectus consectetur sagittis sit tortor imperdiet arcu.
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur. Sollicitudin tincidunt
          molestie senectus consectetur sagittis sit tortor imperdiet arcu.
          Lorem ipsum dolor sit amet consectetur. Sollicitudin tincidunt
          molestie senectus consectetur sagittis sit tortor imperdiet arcu.
        </p>
      </div>

      <!-- Training Topics Section-->
      <section
        class="container py-32 md:px-12 sm:px-12 px-4 max-w-screen-2xl mx-auto bg-cover bg-center mb-10"
        :style="{
          backgroundImage: `url(${require('../assets/images/hero-section.jpg')})`,
        }"
      >
        <div class="bg-black bg-opacity-50"></div>
        <h1 class="text-lg font-bold lg:text-start text-[#ada595] mb-8 -mt-6">
          Training Topics
        </h1>

        <!-- First Row Trainings -->
        <div class="grid grid-cols-1 md:grid-cols-4 gap-2">
          <!-- Introduction Card -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Introduction To RealEstate
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module offers comprehensive instruction on property
                transactions, investment strategies, and legal considerations,
                preparing students for success in the industry.
              </h3>
            </div>
          </div>

          <!-- Nigeria RealEstate -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Venturing into Nigeria Real Estate System
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module offers opportunities for investment and development
                in a rapidly growing market, with potential for lucrative
                returns.
              </h3>
            </div>
          </div>

          <!-- Real Estate Management -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Real Estate Management & Sustainability Planning
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module helps participants to discover how to create
                environmentally responsible properties while maximizing value
                and long-term impact in the real estate industry.
              </h3>
            </div>
          </div>

          <!-- Investment Strategy and Methodology -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Investment Strategy and Methodology
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module helps participants to discover how to create
                environmentally responsible properties while maximizing value
                and long-term impact in the real estate industry.
              </h3>
            </div>
          </div>
        </div>

        <!-- Second Row Trainings -->
        <div class="grid grid-cols-1 md:grid-cols-4 gap-2 mt-6">
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Real Estate Business Development System
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module on explores Real Estate business development system,
                it equips participants with strategies for market analysis,
                client acquisition, growth management and facilitating success
                in the competitive real estate industry.
              </h3>
            </div>
          </div>

          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Marketing & Branding
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module unveils insights into creating impactful campaigns,
                building Brand identity, and leveraging digital platforms to
                reach target audiences effectively.
              </h3>
            </div>
          </div>

          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Real Estate Legal System
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module on Real Estate legal system educates participants on
                property laws, contracts, and regulations, ensuring compliance
                and proficiency in navigating legal complexities within the
                industry.
              </h3>
            </div>
          </div>

          <div class="">
            <div
              class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
            >
              <h3
                class="text-center text-base font-normal mb-3 group-hover:invisible"
              >
                Wealth Management
              </h3>
              <div
                class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <h3 class="text-center p-4 font-normal text-sm">
                  This session on Wealth Management educates individuals on
                  investment strategies, financial planning, and risk mitigation
                  techniques to achieve long-term financial security and
                  prosperity.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import { RouterLink } from "vue-router";

export default {};
</script>

<style scoped>
.card {
  transition: transform 0.2s ease;
}
.card:hover {
  transform: scale(1.02);
}
</style>
